import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Intro from "../components/intro"
import Description from "../components/description"
import Supporters from "../components/supporters"
import Report from "../components/report"

const IndexPage = ({ data }) => {
  const title = data.markdownRemark.frontmatter.title
  const heroContent = data.markdownRemark.frontmatter.hero
  const introContent = data.markdownRemark.frontmatter.intro
  const descriptionContent = data.markdownRemark.frontmatter.description
  const supportersContent = data.markdownRemark.frontmatter.supporters

  return (
    <Layout classes="home" hiddenLogo="true">
      <Seo title={title} />
      <Intro heroContent={heroContent} introContent={introContent} />
      <Report introContent={introContent} />
      <Description descriptionContent={descriptionContent} />
      <Supporters supportersContent={supportersContent} />
    </Layout>
  )
}

export const query = graphql`
  {
    markdownRemark(frontmatter: { template_key: { eq: "home" } }) {
      frontmatter {
        title
        hero {
          small_title
          title
          caption
        }
        intro {
          title
          subtitle
          text
        }
        description {
          title
          text
        }
        supporters {
          title
          text
          title_one
          text_one
          link_one
          title_two
          text_two
          link_two
          title_three
          text_three
          link_three
        }
      }
    }
  }
`

export default IndexPage
